import * as yup from 'yup';

export const AUTH_EMAIL_LIKE_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmailLike = (value: string) => AUTH_EMAIL_LIKE_REGEX.test(value);

export const isEmptyOrEmailLike = (value?: string | null) => {
  const normalizedValue = value?.trim() ?? '';

  return normalizedValue.length === 0 || isEmailLike(normalizedValue);
};

export const isEmailLikeIdentifierReady = (value: string) => {
  const normalizedValue = value.trim();

  return normalizedValue.length > 0 && isEmailLike(normalizedValue);
};

export const buildRequiredEmailLikeSchema = (requiredMessage: string, formatMessage: string) =>
  yup
    .string()
    .trim()
    .required(requiredMessage)
    .test({
      message: formatMessage,
      name: 'auth-email-like',
      test: isEmptyOrEmailLike,
    });
